<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="hardwareMediaList"
            :description="false"
            @selected="handleSelected"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.DetailsOfMedia") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Media' })"
                  size="small"
                  >{{ $t("setup.label.Media") }}</vs-button
                >
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Add Media' })"
                  size="small"
                  >{{ $t("setup.label.AdvMedia") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.MediaTitle") }}</vs-th>
              <vs-th>{{ $t("setup.label.MediaCatagory") }}</vs-th>
              <vs-th>{{ $t("setup.label.ContentProvider") }}</vs-th>
              <vs-th>{{ $t("setup.label.Share") }}</vs-th>
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="hardwareMediaList"
                v-for="(hardwareMediaList, index) in data"
              >
                <vs-td :data="hardwareMediaList.mediaTitle">{{
                  hardwareMediaList.mediaTitle
                }}</vs-td>
                <vs-td :data="hardwareMediaList.mediaCategory">{{
                  hardwareMediaList.mediaCategory
                }}</vs-td>

                <vs-td :data="hardwareMediaList.contentProviderValue">{{
                  hardwareMediaList.contentProviderValue
                }}</vs-td>
                <vs-td :data="hardwareMediaList.cpShareValue">{{
                  hardwareMediaList.cpShareValue
                }}</vs-td>

                <vs-td :data="hardwareMediaList.status">{{
                  hardwareMediaList.status
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.EditMedia')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editCreateDevice(hardwareMediaList.mediaId)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="PlusIcon"
                      :title="$t('setup.label.AddEvent')"
                      class="icon_row"
                      svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                      @click.stop="$router.push({ name: 'Create Event' })"
                    />

                    <feather-icon
                      icon="BookIcon"
                      :title="$t('setup.label.AddAttributes')"
                      svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                      @click.stop="
                        editJobsUomPopup = true;
                        getDiscountTemplate(hardwareMediaList.id);
                      "
                      class="icon_row"
                    />
                    <feather-icon
                      icon="MapPinIcon"
                      :title="$t('setup.label.AddLocation')"
                      class="icon_row"
                      svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                      @click.stop="
                        mediaLocationPopup = true;
                        getLocationDevice(hardwareMediaList.id);
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.MediaAttributes')"
              :active.sync="editJobsUomPopup"
              class="popup-close"
            >
              <div class="vx-row mt-4">
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.Cast')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="attributes.atb4"
                  />
                </div>

                <div class="vx-col w-1/4">
                  <div class="dropdown-with-label">
                    <small class="date-label font-semibold">{{
                      $t("setup.label.AttributeType")
                    }}</small>
                    <v-select
                      label="mediaName"
                      v-model="attributes.mediaName"
                      :options="mediaAttributes"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.CaptionValue')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="attributes.atb1"
                  />
                </div>
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.NickName')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="attributes.atb2"
                  />
                </div>
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.Image')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="attributes.atb3"
                  />
                </div>
                <div class="vx-col md:w-1/8 mt-4" style="margin: 0.5rem 0">
                  <vs-button
                    @click="addParameter"
                    icon-pack="feather"
                    icon="icon-plus"
                    title="add"
                    color="success"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                  >
                  </vs-button>
                </div>
              </div>
              <div class="vx-row mt-6">
                <div class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100">
                  <div class="block">
                    <vs-table
                      style="width: 660px"
                      class="ml-3 mr-2 vx-row w-100"
                      :description-items="paginationItems"
                      description-title="Registries"
                      description-connector="of"
                      description-body="Pages"
                      :data="attributes"
                    >
                      <template slot="thead">
                        <vs-th>{{ $t("setup.label.Cast") }}</vs-th>
                        <vs-th>{{ $t("setup.label.AttributeType") }}</vs-th>
                        <vs-th>{{ $t("setup.label.CaptionValue") }}</vs-th>
                        <vs-th>{{ $t("setup.label.NickName") }}</vs-th>
                        <vs-th>{{ $t("setup.label.Image") }}</vs-th>
                        <vs-th>{{ $t("setup.label.Action") }}</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="attributes"
                          v-for="(
                            attributes, index
                          ) in attributes.attribureDetailDatas"
                        >
                          <vs-td :data="attributes.add4">{{
                            attributes.add4
                          }}</vs-td>
                          <vs-td :data="attributes.categoryType">{{
                            attributes.categoryType
                          }}</vs-td>
                          <vs-td :data="attributes.discountRate">
                            {{ attributes.discountRate }}
                          </vs-td>
                          <vs-td :data="attributes.add2">
                            {{ attributes.add2 }}
                          </vs-td>
                          <vs-td :data="attributes.add3">
                            {{ attributes.add3 }}
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <button
                                @click="removeItem(index)"
                                class="bGNone border-none view_editTable_btn"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                  :title="$t('setup.label.Delete')"
                                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                  class="icon_row"
                                />
                              </button>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <span class="ml-4 mr-1">
                  <vs-button
                    style="margin-left: 230px; margin-top: 50px"
                    type="border"
                    @click="editJobsUomPopup = false"
                    >{{ $t("setup.label.Cancel") }}</vs-button
                  >
                </span>
                <span class="ml-1 mr-2">
                  <vs-button
                    style="margin-top: 50px"
                    @click="createatt(hardwareMediaList.mediaId)"
                    color="primary"
                    >{{ $t("setup.label.Save") }}</vs-button
                  >
                </span>
              </div>
            </vs-popup>
          </div>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.AddMediaLocations')"
              :active.sync="mediaLocationPopup"
              class="popup-close"
            >
              <div class="vx-row mt-4">
                <div class="vx-col w-1/4">
                  <div class="dropdown-with-label">
                    <small class="date-label font-semibold">{{
                      $t("setup.label.LanguageData")
                    }}</small>
                    <v-select
                      label="mCodeValue"
                      v-model="locations.mCodeValue"
                      :options="mediaLanguageData"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col w-1/4">
                  <div class="dropdown-with-label">
                    <small class="date-label font-semibold">{{
                      $t("setup.label.FormatData")
                    }}</small>
                    <v-select
                      label="mediaName"
                      v-model="locations.mediaName"
                      :options="mediaFormat"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>

                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.MediaLocation')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="locations.location1"
                  />
                </div>
                <div class="vx-col md:w-1/8 mt-4" style="margin: 0.5rem 0">
                  <vs-button
                    @click="addLocatioin"
                    icon-pack="feather"
                    icon="icon-plus"
                    :title="$t('setup.label.Add')"
                    color="success"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                  >
                  </vs-button>
                </div>
              </div>
              <div class="vx-row mt-6">
                <div class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100">
                  <div class="block">
                    <vs-table
                      style="width: 660px"
                      class="ml-3 mr-2 vx-row w-100"
                      :description-items="paginationItems"
                      description-title="Registries"
                      description-connector="of"
                      description-body="Pages"
                      :data="locations"
                    >
                      <template slot="thead">
                        <vs-th>{{ $t("setup.label.LanguageData") }}</vs-th>
                        <vs-th>{{ $t("setup.label.FormatData") }}</vs-th>
                        <vs-th>{{ $t("setup.label.MediaLocation") }}</vs-th>
                        <vs-th>{{ $t("setup.label.Action") }}</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="locations"
                          v-for="(
                            locations, index
                          ) in locations.locationsDetailDatas"
                        >
                          <vs-td :data="locations.mCodeValue">{{
                            locations.mCodeValue
                          }}</vs-td>
                          <vs-td :data="locations.discountRate">{{
                            locations.discountRate
                          }}</vs-td>
                          <vs-td :data="locations.loc2">
                            {{ locations.loc2 }}
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <button
                                @click="removeItemLocation(index)"
                                class="bGNone border-none view_editTable_btn"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                  :title="$t('setup.label.Delete')"
                                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                  class="icon_row"
                                />
                              </button>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <span class="ml-4 mr-1">
                  <vs-button
                    style="margin-left: 230px; margin-top: 50px"
                    type="border"
                    @click="mediaLocationPopup = false"
                    >{{ $t("setup.label.Cancel") }}</vs-button
                  >
                </span>
                <span class="ml-1 mr-2">
                  <vs-button
                    style="margin-top: 50px"
                    @click="createatt(hardwareMediaList.mediaId)"
                    color="primary"
                    >{{ $t("setup.label.Save") }}</vs-button
                  >
                </span>
              </div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";

const teamEmptyObj = {
  mediaName: "",
  atb1: "",
  atb2: "",
  atb3: "",
  atb4: "",
  attribureDetailDatas: [],
  categoryType: "",
};
const locationEmptyObj = {
  mediaName: "",
  mCodeValue: "",
  location1: "",
  locationsDetailDatas: [],
  categoryType: "",
};
export default {
  data() {
    return {
      activeTab: 0,
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      mediaAttributes: [],
      mediaLanguageData: [],
      mediaFormat: [],
      attributes: teamEmptyObj,
      locations: locationEmptyObj,
      mediaLocationPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
  },

  computed: {
    ...mapState({
      hardwareMediaList: (state) => state.mediaDetails.Medialist,
      provisioningEventList: (state) => state.mediaDetails.Eventlist,
      template: (state) => state.mediaDetails.AddAttributeTemplateList,
    }),
  },
  methods: {
    async getUomData() {
      try {
        this.$store.dispatch("mediaDetails/setMediaList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    editCreateDevice(id) {
      this.$router.push({ name: "Edit Media", params: { id: id } });
    },
    // async deleteRumTeam(id) {
    // },
    async getDiscountTemplate() {
      try {
        await this.$store.dispatch("mediaDetails/setAddAttributesTemplate");
        this.mediaAttributes = [
          { id: 0, mediaName: "" },
          ...this.template.mediaAttributes,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    removeItem(i) {
      this.attributes.attribureDetailDatas.splice(i, 1);
    },
    addParameter() {
      try {
        let crateParameter = {
          categoryType: this.attributes.mediaName.mediaName,
          categoryId: this.attributes.mediaName.id,
          discountRate: this.attributes.atb1,
          add2: this.attributes.atb2,
          add4: this.attributes.atb4,
          add3: this.attributes.atb3,
        };
        if (this.attributes.mediaName !== "") {
          this.attributes.attribureDetailDatas = [
            ...this.attributes.attribureDetailDatas,
            crateParameter,
          ];
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createatt() {
      try {
        await this.$store.dispatch(
          "mediaDetails/createattributeAction",
          this.id
        );
        this.$router.push("/setup/media-pricing/details");
        this.resetForm();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getLocationDevice() {
      try {
        await this.$store.dispatch("mediaDetails/setAddAttributesTemplate");

        this.mediaLanguageData = [
          { id: 0, mCodeValue: "" },
          ...this.template.mediaLanguageData,
        ];
        this.mediaFormat = [
          { id: 0, mediaName: "" },
          ...this.template.mediaFormat,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    removeItemLocation(i) {
      this.locations.locationsDetailDatas.splice(i, 1);
    },
    addLocatioin() {
      try {
        let crateParameter = {
          mCodeValue: this.locations.mCodeValue.mCodeValue,
          discountRate: this.locations.mediaName.mediaName,
          loc2: this.locations.location1,
        };
        if (this.locations.mediaName !== "") {
          this.locations.locationsDetailDatas = [
            ...this.locations.locationsDetailDatas,
            crateParameter,
          ];
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.getUomData();

    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 50%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.under_input {
  width: 140px;
}
</style>
